import React, { createContext, useContext, useState } from 'react';

// ---------------------------------------------------------------------------------------------------------------

/** @type {React.Context<null | { loading: boolean; setLoading: (boolean) => void }>} */
const LoaderContext = createContext(null);

const useInitContext = () => {
  const [loading, setLoading] = useState(false);
  return {
    loading: loading,
    setLoading: (value) => {
      if (typeof value == 'boolean') {
        setLoading(value);
      } else {
        setLoading(false);
      }
    },
  };
};

// ---------------------------------------------------------------------------------------------------------------

/**
 * @return {{ loading: boolean, setLoading: (boolean) => void }}
 */
export const useLoaderContext = () => {
  const ctx = useContext(LoaderContext);
  if (ctx == null) {
    throw new Error('Loader context is not init!');
  }
  return ctx;
};

export const LoaderProvider = ({ children }) => {
  const value = useInitContext();
  return <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>;
};

export const wrapWithLoaderProvider = (Component) => {
  return (props) => (
    <LoaderProvider>
      <Component {...props} />
    </LoaderProvider>
  );
};
